module.exports = __webpack_public_path__ + "card-stack@3x.png?041dc3f79b5b1f36bff0ef2875edfefd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card-stack@3x.png
// module id = 579
// module chunks = 0